import $ from '@nuskin/nuskinjquery';
import '@nuskin/ns-util';
import LtoCartItem from './ltoCartItem.js';

let LtoCart = function(){

    let _cartItemHashTable = new $.Hashtable();

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    this.toJSON = function(){
        let jsonData = {
            "products" : []
        };

        let cartItems = getCartItems();
        for (let i=0;i<cartItems.length;i++){
            jsonData.products.push(cartItems[i].toJSON());
        }

        return jsonData;
    };

    // todo prevent duplicates
    this.addCartItem = function(item){
        if (item instanceof LtoCartItem){
            _cartItemHashTable.add(item.sku,item);
        }
    };

    // todo prevent duplicates
    this.addItem = function(sku, qty, maxQty){
        let item = new LtoCartItem(sku, qty, maxQty);
        _cartItemHashTable.add(item.sku,item);
    };

    this.getItemBySku = function(sku){
        return _cartItemHashTable.get(sku);
    };

    this.getItems = function(){
        return getCartItems();
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function getCartItems(){
        let keys = Object.keys(_cartItemHashTable.items);
        let cartItems = [];

        for (let i=0;i<keys.length;i++){
            cartItems.push(_cartItemHashTable.get(keys[i]));
        }

        return cartItems;
    }
};

export default LtoCart;
